import { Setor } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { ContratoTerceirizadoStorage } from './contrato-terceirizado-storage.model';
import { Contrato } from './contrato.model';

export class ContratoTerceirizado extends BaseResourceModel {
  constructor(
    public id?: number,
    public contrato?: Contrato,
    public nome?: string,
    public cargo?: string,
    public cpf?: string,
    public setor?: Setor,
    public data_admissao?: Date,
    public data_demissao?: Date,
    public arquivos?: ContratoTerceirizadoStorage[],
    public ativo?: boolean,
  ) {
    super();
  }
  static converteJson(json: any): ContratoTerceirizado {
    return Object.assign(new ContratoTerceirizado(), json);
  }
}